export default "__VITE_ASSET__DPIb0b6D__"